import { Events } from "@/models/database/event/Events.model";
import { create } from "zustand";

interface EventsState {
  events: Events[] | null;
  loading: boolean;
  error: Error | null;
  setEvents: (events: Events[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  getEventsBySlug: (slug: string) => Events | undefined;
  addEvents: (eventItem: Events) => void;
}

export const useEventsStore = create<EventsState>((set, get) => ({
  events: null,
  loading: true,
  error: null,
  setEvents: (events) => set({ events }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  getEventsBySlug: (slug) => {
    const { events } = get();
    return events?.find((item) => item.slug === slug);
  },
  addEvents: (eventItem) => {
    const { events } = get();
    set({ events: events ? [...events, eventItem] : [eventItem] });
  },
}));
